import { call, put } from 'redux-saga/effects';
import { questionnaireEvaluationQuestionGetSuccessAction, questionnaireEvaluationFailureAction } from '../actions';
import { QuestionnaireEvaluationQuestionService } from '../services';
export function* questionnaireEvaluationQuestionGetSaga(action, questionnaireEvaluationQuestionService = new QuestionnaireEvaluationQuestionService()) {
    try {
        const questionData = yield call({
            context: questionnaireEvaluationQuestionService,
            fn: questionnaireEvaluationQuestionService.questionnaireEvaluationGetQuestion
        }, action.payload);
        yield put(questionnaireEvaluationQuestionGetSuccessAction(questionData));
    }
    catch (error) {
        yield put(questionnaireEvaluationFailureAction(error.toString()));
    }
}
//# sourceMappingURL=questionnaireEvaluationQuestionGetSaga.js.map